import type { TerminalSchema } from "@wishlink/applens-core";
import type { QueryTiming, DependencyTimings } from "@wishlink/applens-core";
import type { IntentSnapshot } from "./intentDependency";

/** SDK-free pre-import snapshot: copy timing and data presence, never payloads. */
export function queryTiming(
  query: QueryTiming & { data?: unknown }
): QueryTiming {
  return {
    startedTimeStamp: query.startedTimeStamp,
    fulfilledTimeStamp: query.fulfilledTimeStamp,
    status: query.status,
    hasData: query.data !== undefined,
  };
}
export function dependencySnapshot(
  input: DependencyTimings & { intent?: IntentSnapshot }
) {
  const copy = (query?: QueryTiming): QueryTiming | undefined =>
    query && {
      startedTimeStamp: query.startedTimeStamp,
      fulfilledTimeStamp: query.fulfilledTimeStamp,
      status: query.status,
      hasData: query.hasData,
    };
  return {
    creator_data: copy(input.creator_data),
    creator_config: copy(input.creator_config),
    intent: {
      enabled: input.intent?.enabled === true,
      query: input.intent?.enabled ? copy(input.intent.query) : undefined,
    },
  };
}
export type {
  QueryTiming,
  DependencyTimings,
  HomeDependencies,
} from "@wishlink/applens-core";
const dependencyRule = {
  type: "enum",
  values: ["network", "inflight", "cache", "absent"],
  default: "absent",
} as const;
export const HOME_TERMINAL_SCHEMA: TerminalSchema = {
  "app.dep.creator_data": dependencyRule,
  "app.dep.creator_config": dependencyRule,
  "app.dep.intent": dependencyRule,
};
